var headerHeightScrolled = 110;

(function($) {
  // smooth scroll on page load with hash
  if(window.location.hash) {
    $(window).load(function(){
      smoothScroll(window.location.hash);
    });    
  }

  // smooth scroll on click
  $('a[href*="#"]:not([href="#"])').click(function(e) {
      e.preventDefault();
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {        
        smoothScroll(this.hash);
        return false;
      }      
  });

  function smoothScroll(target) { 
    target = $(target).length ? $(target) : $('[name=' + target.slice(1) +']');   
    if (target.length) {
      console.log('smooth scrolling to '+target);
      var offset = headerHeightScrolled + 10;
      $('html, body').animate({
        scrollTop: target.offset().top - offset
      }, 1000, function(){
        console.log('done smooth scroll');
      });      
    }
  }

})( jQuery ); 